
































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import searchInput from "@/components/searchInput.vue";
import passwordModal from "@/views/usercenter/passwordModal.vue";
import util from "@/lib/util";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import _ from "lodash";
import Util from "@/lib/util";
import AppConsts from "@/lib/appconst";

import ASwitch from 'ant-design-vue/es/switch'
import AList from 'ant-design-vue/es/list'
import AListItem from 'ant-design-vue/es/list/Item'
import {paginationElement} from "@/api/typeDefined";

const Meta = AListItem.Meta;

@Component({
    components: {
        searchInput,
    },
    filters: {
        imgUrlFilter(url: string = '') {
            if (url && url.indexOf('http') > -1) {
                return url;
            } else {
                let fileResourceUrl: string = AppConsts.fileResourceUrl;
                return `${fileResourceUrl}${url}`;
            }
        }
    }
})
export default class myCollectQA extends basicPage {
    customActiveKey = '0'
    hasHeight: boolean = false;
    data: any = {};
    resourcesPath: string = '';
    form: any;

    pagination: paginationElement = {
        ...AppConsts.pagination,
        onShowSizeChange: (pageIndex, size) => {
            this.pagination.current = pageIndex;
            this.pagination.pageSize = size;
            this.loadData();
        },
        onChange: pageIndex => {
            this.pagination.current = pageIndex;
            this.loadData();
        }
    };

    //初始化分页参数
    initPagination() {
        this.pagination = {
            ...AppConsts.pagination,
            onShowSizeChange: (pageIndex, size) => {
                this.pagination.current = pageIndex;
                this.pagination.pageSize = size;
                this.loadData();
            },
            onChange: pageIndex => {
                this.pagination.current = pageIndex;
                this.loadData();
            }
        };
    }

    loadData() {
        let {current, pageSize} = this.pagination;
        let queryParams = {
            currentPage: current,
            pageSize: pageSize,
            collectType: 4,
        };

        let url: string = '/web/user/collect';
        ajaxHelperInstance.get(url, queryParams, undefined, this).then((res) => {
            let {status, data} = res;
            if (status === 200) {
                this.data = data.data || [];
                this.pagination.total = 0;
                if (data) {
                    let {page} = data;
                    if (page) {
                        console.table(data.data);
                        this.pagination.total = page.total;
                    }
                }
            }
        });
    }

    handleShowDetail(questionId: string) {
        this.switchRouting('QADetail', {
            queryParams: JSON.stringify({
                keywords: "",
                questionId: questionId,
                skip: false
            })
        });
    }

    mounted() {
        this.loadData();
        // this.loadData();
    }
}
